import { CommonModule } from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {ExamService} from "../../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {DropdownMenuComponent, MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {ActivatedRoute, Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../../shared/ui/outline-button/outline-button.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {APIResponse} from "../../../../shared/data-access/api-response.model";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../../shared/ui/full-button/full-button.component";
import _ from "lodash";
import {faCaretDown, faChevronLeft, faChevronRight, faPlus, faX} from "@fortawesome/free-solid-svg-icons";
import { DropdownSearchComponent } from 'src/app/shared/ui/dropdown-search/dropdown-search.component';
import {ClearButtonComponent} from "../../../../shared/ui/clear-button/clear-button.component";

interface Comments {
  username: string
  examinstancecomment_id: number
  examinstance_id: number
  user_id: number
  comment: string
  createdate: Date
}
@Component({
    selector: 'exam-instance-comments',
    templateUrl: './exam-instance-comments.component.html',
    styleUrls: ['../../list/list.component.css'],
    imports: [CommonModule, FontAwesomeModule, DropdownMenuComponent, OutlineButtonComponent, DropdownSearchComponent, FormsModule, MatIconModule, FullButtonComponent, ClearButtonComponent]
})
export class ExamInstanceCommentsComponent implements OnInit {
  route = inject(ActivatedRoute);
  router = inject(Router)
  examService = inject(ExamService)
  _snackBar = inject(MatSnackBar)
  instanceCommentsResponse: Comments[] = []
  examName = ''
  examID = -1
  examUUID = ''
  addCommentDialog = false
  commentToAdd = ''
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if(params['exam_uuid']) {
        this.examUUID = params['exam_uuid']
        this.getComments()
      }
    })
  }

  getComments() {
    if(this.examUUID !== '') {
      this.examService.reviewExamInstance(this.examUUID).subscribe((response: APIResponse) => {
        if (response.success) {
          this.instanceCommentsResponse = response.result.comments
          this.examName = response.result.details.exam_title
          this.examID = response.result.details.exam_id
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {duration: 3000, panelClass: ['error-snackbar']})
        }
      })
    }
  }

  examInstances() {
    this.router.navigate(['dashboard/exam/instances'], {queryParams: {exam_id: this.examID, exam_title: this.examName}})
  }

  examList() {
    this.router.navigate(['dashboard/exam/list'])
  }

  openAddCommentDialog() {
    this.addCommentDialog = true
  }

  addCommentSave() {
    if(this.examUUID !== '') {
      this.examService.recordExamInstanceComment(this.examUUID, this.commentToAdd).subscribe((response) => {
        if(response.success) {
          this.getComments()
          this._snackBar.open('Comment Successfully Added', 'Dismiss', {duration: 3000})
          this.addCommentDialog = false
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    } else {
      this._snackBar.open('Exam UUID is empty', 'Dismiss', {panelClass: ['error-snackbar']})
    }
  }

  addCommentCancel() {
    this.commentToAdd =''
    this.addCommentDialog = false
  }

  protected readonly faPlus = faPlus;
}
